/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-05-22 13:12:16
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2021-08-19 16:08:09
 * @LastEditTime: 2020-08-07 18:32:17
 */
import { request } from "./api-require";
const API_URL = "/oms-operation-service/v1";
export const getMonitorGunStatus = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/monitor/gun/status", data, config);
};
export const getMonitorPileGrid = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/monitor/pile/grid", data, config);
};
export const getMonitorPileData = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/monitor/pile/data", data, config);
};
export const getMonitorGunInfo = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/monitor/gun/info", data, config);
};
/**
 * 获取站下全部桩及枪的数量
 * @param data
 * @param config
 * @returns
 */
export const getMonitorTotalPileGun = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/monitor/total/pile_gun", data, config);
};
export const getMerchantPage = (data = {}, config = {}) => {
    return request(API_URL + "/opr/merchant/page", data, config);
};
/**
 *  获取商户详情
 * @param data
 * @param config
 * @returns
 */
export const getMerchantDetail = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/merchant/detail", data, config);
};
/**
 *  删除商户
 * @param data
 * @param config
 * @returns
 */
export const delMerchant = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/opr/merchant/del", data, config);
};
/**
 *
 * @param data 新增商户
 * @param config
 * @returns
 */
export const addMerchant = (data = {}, config = {}) => {
    return request(API_URL + "/opr/merchant/add", data, config);
};
/**
 *
 * @param data 修改商户
 * @param config
 * @returns
 */
export const updMerchant = (data = {}, config = {}) => {
    return request(API_URL + "/opr/merchant/upd", data, config);
};
/**
 * 获取站点列表
 * @param data
 * @param config
 * @returns
 */
export const getStaPage = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/page", data, config);
};
/**
 * 获取充电站详情
 */
export const getStaDetail = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/detail", data, config);
};
/**
 *
 * @param data 查询站点电价列表
 * @param config
 */
export const getStaFeeDetails = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/fee/detail", data, config);
};
/**
 *  新增站点
 * @param data
 * @param config
 * @returns
 */
export const addSta = (data = {}, config = {}) => {
    return request(API_URL + "/opr/sta/add", data, config);
};
/**
 *  修改站点
 * @param data
 * @param config
 * @returns
 */
export const updSta = (data = {}, config = {}) => {
    return request(API_URL + "/opr/sta/upd", data, config);
};
/**
 *  修改充电站状态
 * @param data
 * @param config
 * @returns
 */
export const updStationStatus = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/opr/sta/upd_station_status", data, config);
};
/**
 * 查询费率模板信息
 */
export const getFeeInfo = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/fee/info", data, config);
};
/**
 * 查询站点下拉列表,站点id 站点名称
 */
export const getOprStaList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/list", data, config);
};
/**
 *
 * @param data 删除站点费率
 * @param config
 */
export const delStaFee = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/delete_fee", data, config);
};
/**
 * 新增/修改充电站绑定费率模板
 */
export const bindStaFee = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/bind_fee", data, config);
};
/**
 *  站点已关联商户信息接口
 * @param data
 * @param config
 * @returns
 */
export const getAssociatedSta = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/associated/sta", data, config);
};
/**
 *  站点取消关联商户接口
 * @param data
 * @param config
 * @returns
 */
export const staUnbindMerchant = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/unbind/merchant", data, config);
};
/**
 *  站点关联商户接口
 * @param data
 * @param config
 * @returns
 */
export const staBindMerchant = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/bind/merchant", data, config);
};
/**
 *  查询商户类型下拉列表
 * @param data
 * @param config
 * @returns
 */
export const merchantListSimple = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/merchant/list_simple", data, config);
};
/**
 *  查询费率下拉列表,费率feePkId - 费率名称
 * @param data
 * @param config
 * @returns
 */
export const getFeeList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/fee/list", data, config);
};
/**
 *  查询商户下站点列表
 * @param data
 * @param config
 * @returns
 */
export const getMchStaList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/merchant/list", data, config);
};
/**
 *  获取运营商配置信息
 * @param data
 * @param config
 * @returns
 */
export const getConfigInfo = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/get_congif_info", data, config);
};
/**
 *  获取登录账户信息
 * @param data
 * @param config
 * @returns
 */
export const getLoginInfo = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/get_login_info", data, config);
};
/**
 *  首页 - 资产
 * @param data
 * @param config
 * @returns
 */
export const getHomeStatAssets = (data = {}, config = {}) => {
    return request(API_URL + "/stat/assets", data, config);
};
/**
 *  首页 - 站点地图查询站点列表
 * @param data
 * @param config
 * @returns
 */
export const getMapStaList = (data = {}, config = {}) => {
    return request(API_URL + "/map/sta/list", data, config);
};
/**
 *  首页 - 站点地图查看站点信息
 * @param data
 * @param config
 * @returns
 */
export const getMapStaInfo = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/map/sta/info", data, config);
};
/**
 *  获取运营商信息
 * @param data
 * @param config
 * @returns
 */
export const getOprInfo = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/get_opr_info", data, config);
};
/**
 *  GET查询运营商列表
 * @param data
 * @param config
 * @returns
 */
export const getOprList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/list", data, config);
};
/**
 *  获取运营商系统头信息
 * @param data
 * @param config
 * @returns
 */
export const getSysHeader = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sys_header", data, config);
};
/**
 *  获取运营商系统头信息
 * @param data
 * @param config
 * @returns
 */
export const updCongifInfo = (data = {}, config = {}) => {
    return request(API_URL + "/opr/upd_congif_info", data, config);
};
/**
 *  修改
 * @param data
 * @param config
 * @returns
 */
export const updOprInfo = (data = {}, config = {}) => {
    return request(API_URL + "/opr/upd_opr_info", data, config);
};
/**
 *  获取充电站---商户
 * @param data
 * @param config
 * @returns
 */
export const getStaKvs = (data = {}, config = {}) => {
    return request(API_URL + "/stat/sta_kvs", data, config);
};
/**
 *  获取充电桩
 * @param data
 * @param config
 * @returns
 */
export const getPileKvs = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/stat/pile_kvs", data, config);
};
/**
 *  获取商户
 * @param data
 * @param config
 * @returns
 */
export const getMerKvs = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/stat/mer_kvs", data, config);
};
/**
 * 获取会员和电卡统计
 * @param data
 * @param config
 * @returns
 */
export const getCardStatistics = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/card/statistics", data, config);
};
/**
 * 获取会员和电卡统计
 * @param data
 * @param config
 * @returns
 */
export const getCardPage = (data = {}, config = {}) => {
    return request(API_URL + "/card/page", data, config);
};
/**
 * 关联电卡
 * @param data
 * @param config
 * @returns
 */
export const getCardBind = (data = {}, config = {}) => {
    return request(API_URL + "/card/bind", data, config);
};
/**
 * 取消关联电卡
 * @param data
 * @param config
 * @returns
 */
export const getCardUnbind = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/card/unbind", data, config);
};
/**
 * 电卡详情
 * @param data
 * @param config
 * @returns
 */
export const getCardDetail = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/card/detail", data, config);
};
/**
 * 获取企业会员统计数据
 * @param data
 * @param config
 * @returns
 */
export const getEntUserStatistics = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/ent_user/statistics", data, config);
};
/**
 * 分页获取企业会员基本信息列表
 * @param data
 * @param config
 * @returns
 */
export const getEntUserPage = (data = {}, config = {}) => {
    return request(API_URL + "/ent_user/page", data, config);
};
/**
 * 分页获取企业会员基本信息列表
 * @param data
 * @param config
 * @returns
 */
export const getEntUserUpd = (data = {}, config = {}) => {
    return request(API_URL + "/ent_user/upd", data, config);
};
/**
 * 分页获取企业会员基本信息列表
 * @param data
 * @param config
 * @returns
 */
export const getEntUserNotExistSta = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/ent_user/not_exist_sta", data, config);
};
/**
 * 站点配置
 * @param data
 * @param config
 * @returns
 */
export const getEntUserConfigSta = (data = {}, config = {}) => {
    return request(API_URL + "/ent_user/config_sta", data, config);
};
/**
 * 已添加站点
 * @param data
 * @param config
 * @returns
 */
export const getEntUserAlreadyExistSta = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/ent_user/already_exist_sta", data, config);
};
/**
 * 新增企业会员
 * @param data
 * @param config
 * @returns
 */
export const getEntUserAdd = (data = {}, config = {}) => {
    return request(API_URL + "/ent_user/add", data, config);
};
/**
 * 查询费率下拉列表,费率feePkId - 费率名称
 * @param data
 * @param config
 * @returns
 */
export const getOprFeeList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/fee/list", data, config);
};
/**
 * 分页获取企业成员列表
 * @param data
 * @param config
 * @returns
 */
export const getEntSubUserPage = (data = {}, config = {}) => {
    return request(API_URL + "/ent_sub_user/page", data, config);
};
/**
 * 删企业成员列表
 * @param data
 * @param config
 * @returns
 */
export const getEntSubUserDel = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/ent_sub_user/del", data, config);
};
/**
 * 修改企业成员列表
 * @param data
 * @param config
 * @returns
 */
export const getEntSubUserUpd = (data = {}, config = {}) => {
    return request(API_URL + "/ent_sub_user/upd", data, config);
};
/**
 * 新增企业成员列表
 * @param data
 * @param config
 * @returns
 */
export const getEntSubUserAdd = (data = {}, config = {}) => {
    return request(API_URL + "/ent_sub_user/add", data, config);
};
/**
 * 运营-统计数据
 * @param data
 * @param config
 * @returns
 */
export const getOptData = (data = {}, config = {}) => {
    return request(API_URL + "/stat/opt/data", data, config);
};
/**
 * 运营-图表数据
 * @param data
 * @param config
 * @returns
 */
export const getOptChart = (data = {}, config = {}) => {
    return request(API_URL + "/stat/opt/chart", data, config);
};
/**
 * 运营-表格数据
 * @param data
 * @param config
 * @returns
 */
export const getOptGrid = (data = {}, config = {}) => {
    return request(API_URL + "/stat/opt/grid", data, config);
};
/**
 * 运营-今日表格数据
 * @param data
 * @param config
 * @returns
 */
export const getOptTodayChart = (data = {}, config = {}) => {
    return request(API_URL + "/stat/opt/today_chart", data, config);
};
/**
 * 运营-今日统计数据
 * @param data
 * @param config
 * @returns
 */
export const getOptTodayData = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/stat/mch/today_data", data, config);
};
/**
 *  一号多冲
 * @param data
 * @param config
 * @returns
 */
export const getMultiChargeList = (data = {}, config = {}) => {
    return request(API_URL + "/opr/multicharge/page", data, config);
};
/**
 *  一号多冲-审核
 * @param data
 * @param config
 * @returns
 */
export const auditMultiCharge = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/opr/multicharge/audit_multiCharge", data, config);
};
/**
 *
 * @param data
 * @param config
 * @returns
 */
/**
 * 运营-充电桩键值对集合
 * @param data
 * @param config
 * @returns
 */
export const getStatPileKvs = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/stat/pile_kvs", data, config);
};
/**
 * 公告信息分页列表
 * @param data
 * @param config
 * @returns
 */
export const getOprNoticeInfoList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/oprNoticeInfo/page", data, config);
};
/**
 * 系统公告分页列表
 * @param data
 * @param config
 * @returns
 */
export const getOprNoticeInfoSystemList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/notice/info/system/page", data, config);
};
/**
 * 分页查询意见
 * @param data
 * @param config
 * @returns
 */
export const getFeedBackList = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/opr/feed/back/page", data, config);
};
/**
 * 客户消息分页查询
 * @param data
 * @param config
 * @returns
 */
export const getFeedBackContentList = (data = {}, config = {}) => {
    return request(API_URL + "/opr/feed/back/page/content", data, config);
};
/**
 * 反馈处理 (回复)
 * @param data
 * @param config
 * @returns
 */
export const feedBackHandle = (data = {}, config = {}) => {
    return request(API_URL + "/opr/feed/back/handle", data, config);
};
/**
 * 用户指南分页查询
 * @param data
 * @param config
 * @returns
 */
export const getOprUserGuideArticle = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/user/guide/page", data, config);
};
/**
 * 删除文章
 * @param data
 * @param config
 * @returns
 */
export const delOprUserGuideArticle = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/user/guide/delete", data, config);
};
/**
 * 新增文章
 * @param data
 * @param config
 * @returns
 */
export const addOprUserGuideArticle = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/user/guide/add", data, config);
};
/**
 * 修改文章
 * @param data
 * @param config
 * @returns
 */
export const upOprUserGuideArticle = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/user/guide/update", data, config);
};
/**
 * 目录名称列表
 * @param data
 * @param config
 * @returns
 */
export const getOprUserGuideMenuAll = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/directory/management/list", data, config);
};
/**
 * 目录管理分页查询
 * @param data
 * @param config
 * @returns
 */
export const getOprUserGuideMenuList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/directory/management/page", data, config);
};
/**
 * 新增目录
 * @param data
 * @param config
 * @returns
 */
export const addOprUserGuideMenu = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/directory/management/add", data, config);
};
/**
 * 更新目录
 * @param data
 * @param config
 * @returns
 */
export const upOprUserGuideMenu = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/directory/management/update", data, config);
};
/**
 * 删除目录
 * @param data
 * @param config
 * @returns
 */
export const delOprUserGuideMenu = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/directory/management/delete", data, config);
};
/**
 * 财务统计-表格数据
 * @param data
 * @param config
 * @returns
 */
export const getStatFinanceGrid = (data = {}, config = {}) => {
    return request(API_URL + "/stat/finance/grid", data, config);
};
/**
 * 账户月度收支图表数据
 * @param data
 * @param config
 * @returns
 */
export const getaAcctViewChart = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/acct_view/month/chart", data, config);
};
/**
 * 账户月度收支表格数据
 * @param data
 * @param config
 * @returns
 */
export const getaAcctViewGrid = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/acct_view/month/grid", data, config);
};
/**
 * 运营-活跃人数表格数据
 * @param data
 * @param config
 * @returns
 */
export const getOptActiveGrid = (data = {}, config = {}) => {
    return request(API_URL + "/stat/opt/active/grid", data, config);
};
/**
 * 充电枪健值对集合
 * @param data
 * @param config
 * @returns
 */
export const getStatGunKvs = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/stat/gun_kvs", data, config);
};
/**
 * 分页获取充电站报表信息
 * @param data
 * @param config
 * @returns
 */
export const getOprReportStaPage = (data = {}, config = {}) => {
    return request(API_URL + "/opr/report/charge/sta", data, config);
};
/**
 * 分页获取充电桩报表信息
 * @param data
 * @param config
 * @returns
 */
export const getOprReportPilePage = (data = {}, config = {}) => {
    return request(API_URL + "/opr/report/charge/pile", data, config);
};
/**
 * 分页获取渠道报表信息
 * @param data
 * @param config
 * @returns
 */
export const getOprReportChannelPage = (data = {}, config = {}) => {
    return request(API_URL + "/opr/report/channel", data, config);
};
/**
 * 分页获取电卡报表信息
 * @param data
 * @param config
 * @returns
 */
export const getOprReportChargePage = (data = {}, config = {}) => {
    return request(API_URL + "/opr/report/charge/card", data, config);
};
/**
 * 分页获取企业报表信息
 * @param data
 * @param config
 * @returns
 */
export const getOprReportConnectPage = (data = {}, config = {}) => {
    return request(API_URL + "/opr/report/enterprise", data, config);
};
/**
 * 分页查询公告内容
 * @param data
 * @param config
 * @returns
 */
export const getNoticeList = (data = {}, config = {}) => {
    return request(API_URL + "/notice/info/page/notice", data, config);
};
/**
 * 删除公告内容
 * @param data
 * @param config
 * @returns
 */
export const delNotice = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/notice/info/delete/station/notice", data, config);
};
/**
 * 添加站点公告内容
 * @param data
 * @param config
 * @returns
 */
export const addNotice = (data = {}, config = {}) => {
    return request(API_URL + "/notice/info/add/station/notice", data, config);
};
/**
 * 添加系统公告内容
 * @param data
 * @param config
 * @returns
 */
export const addWxNotice = (data = {}, config = {}) => {
    return request(API_URL + "/notice/info/add/system/notice", data, config);
};
/**
 * 删除公告内容
 * @param data
 * @param config
 * @returns
 */
export const oprStaDel = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/opr/sta/del", data, config);
};
/**
 * 分页查询优惠券模板
 * @param data
 * @param config
 * @returns
 */
export const getCouponList = (data = {}, config = {}) => {
    return request(API_URL + "/coupon/template/page", data, config);
};
/**
 * 新增优惠券模板
 * @param data
 * @param config
 * @returns
 */
export const addCoupon = (data = {}, config = {}) => {
    return request(API_URL + "/coupon/template/add", data, config);
};
/**
 * 修改优惠券模板
 * @param data
 * @param config
 * @returns
 */
export const updateCoupon = (data = {}, config = {}) => {
    return request(API_URL + "/coupon/template/update", data, config);
};
/**
 * 优惠券模板详情
 * @param data
 * @param config
 * @returns
 */
export const getCouponDetail = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/coupon/template/detail", data, config);
};
/**
 * 审核优惠券
 * @param data
 * @param config
 * @returns
 */
export const auditCoupon = (data = {}, config = {}) => {
    return request(API_URL + "/coupon/template/audit", data, config);
};
/**
 * 审核优惠券
 * @param data
 * @param config
 * @returns
 */
export const delCoupon = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/coupon/template/delete", data, config);
};
/**
 * 优惠券及单次发放数量集合
 * @param data
 * @param config
 * @returns
 */
export const getTemplateCouponList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/coupon/template/coupon/list", data, config);
};
/**
 * 分页查询营销活动
 * @param data
 * @param config
 * @returns
 */
export const getCampaign = (data = {}, config = {}) => {
    return request(API_URL + "/campaign/page", data, config);
};
/**
 * 新增营销活动
 * @param data
 * @param config
 * @returns
 */
export const addCampaign = (data = {}, config = {}) => {
    return request(API_URL + "/campaign/add", data, config);
};
/**
 * 修改营销活动
 * @param data
 * @param config
 * @returns
 */
export const updateCampaign = (data = {}, config = {}) => {
    return request(API_URL + "/campaign/update", data, config);
};
/**
 * 营销活动详情
 * @param data
 * @param config
 * @returns
 */
export const getCampaignDetail = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/campaign/detail", data, config);
};
/**
 * 审核营销活动
 * @param data
 * @param config
 * @returns
 */
export const auditCampaign = (data = {}, config = {}) => {
    return request(API_URL + "/campaign/audit", data, config);
};
/**
 * 停用营销活动
 * @param data
 * @param config
 * @returns
 */
export const stopCampaign = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/campaign/block/up", data, config);
};
/**
 * 获取当前运营商所有站点集合
 * @param data
 * @param config
 * @returns
 */
export const getCampaignStationList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/campaign/station/list", data, config);
};
/**
 * 分页查询用户优惠券
 * @param data
 * @param config
 * @returns
 */
export const getUserCoupon = (data = {}, config = {}) => {
    return request(API_URL + "/user/coupon/page", data, config);
};
/**
 * 站点提交审核
 * @param data
 * @param config
 * @returns
 */
export const submitApplications = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/submit_applications", data, config);
};
/**
 * 站点审核
 * @param data
 * @param config
 * @returns
 */
export const auditApplications = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/audit_applications", data, config);
};
/**
 * 维护记录
 * @param data
 * @param config
 * @returns
 */
export const getStaMaintenanceRecord = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/maintenance_record", data, config);
};
/**
 * 现场调试
 * @param data
 * @param config
 * @returns
 */
export const fieldDebugging = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/field_debugging", data, config);
};
/**
 * 费率审核
 * @param data
 * @param config
 * @returns
 */
export const auditFeeApplications = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/fee/audit_fee_applications", data, config);
};
/**
 * 修改操作密码
 * @param data
 * @param config
 * @returns
 */
export const modifyOperation = (data = {}, config = {}) => {
    return request(API_URL + "/opr/modify_operation", data, config);
};
/**
 * 查询标签信息
 * @param data
 * @param config
 * @returns
 */
export const getTagList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/tag/list", data, config);
};
/**
 * 新增标签信息
 * @param data
 * @param config
 * @returns
 */
export const addTag = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/opr/tag/insert", data, config);
};
/**
 * 删除标签信息
 * @param data
 * @param config
 * @returns
 */
export const delTag = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/opr/tag/delete", data, config);
};
/**
 *  获取商户信息
 * @param data
 * @param config
 * @returns
 */
export const getMerchantInfo = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/merchant/detail", data, config);
};
/**
 *  首页--结算信息
 * @param data
 * @param config
 * @returns
 */
export const getMerchantSettlement = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/stat/mch/settlement", data, config);
};
/**
 * 获取运营商配置信息
 * @param data
 * @param config
 * @returns
 */
export const getCongifInfo = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/get_congif_info", data, config);
};
/**
 * 获取运营商配置信息
 * @param data
 * @param config
 * @returns
 */
export const getOperBacklog = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/backlog/mch/detail", data, config);
};
/**
 *  电卡详情
 * @param data
 * @param config
 * @returns
 */
export const getCardDetails = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/recharge_card/detail", data, config);
};
/**
 *  开卡
 * @param data
 * @param config
 * @returns
 */
export const openCard = (data = {}, config = {}) => {
    return request(API_URL + "/recharge_card/open_card", data, config);
};
/**
 *  获取加密运营商编码
 * @param data
 * @param config
 * @returns
 */
export const getByMchIdCustomerId = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/recharge_card/customerId", data, config);
};
/**
 *  读卡
 * @param data
 * @param config
 * @returns
 */
export const readCard = (data = {}, config = {}) => {
    return request(API_URL + "/recharge_card/read_card", data, config);
};
/**
 *  获取新开卡的卡号
 * @param data
 * @param config
 * @returns
 */
export const getCardSerialNumber = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/recharge_card/get_card_serial_number", data, config);
};
/**
 *  注销
 * @param data
 * @param config
 * @returns
 */
export const cancelCard = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/recharge_card/cancel_card", data, config);
};
/**
 *  分页查询充电站费率追踪列表
 * @param data
 * @param config
 * @returns
 */
export const getStaFeeTrailPage = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/fee/trail/page", data, config);
};
/**
 * 获取发票分页
 * @param data
 * @param config
 * @returns
 */
export const getOprInvoicePage = (data = {}, config = {}) => {
    return request(API_URL + "/opr/invoice/page", data, config);
};
/**
 *  更新审核设置
 * @param data
 * @param config
 * @returns
 */
export const getUpdateAuditSettings = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/invoice/update/audit_settings", data, config);
};
/**
 *  统计发票相关数据信息
 * @param data
 * @param config
 * @returns
 */
export const getInvoiceInfo = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/invoice/stat/invoice_info", data, config);
};
/**
 *  开票
 * @param data
 * @param config
 * @returns
 */
export const getOprInvoiceDraw = (data = {}, config = {}) => {
    return request(API_URL + "/opr/invoice/draw", data, config);
};
/**
 * 发票详情
 * @param data
 * @param config
 * @returns
 */
export const getOprInvoiceDetail = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/invoice/detail", data, config);
};
/**
 *  发票操作详情
 * @param data
 * @param config
 * @returns
 */
export const getOprInvoiceOperationDetail = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/invoice/operation/detail", data, config);
};
/**
 *  审核
 * @param data
 * @param config
 * @returns
 */
export const getOprInvoiceAudit = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/invoice/audit", data, config);
};
/**
 * 获取所有企业会员基本信息列表
 * @param data
 * @param config
 * @returns
 */
export const getAllEntUserPage = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/ent_user/list", data, config);
};
/**
 * 查询订单归属信息
 * @param data
 * @param config
 * @returns
 */
export const getOrderBelong = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/reservation/order/belong", data, config);
};
/**
 * 分页获取预约充电订单
 * @param data
 * @param config
 * @returns
 */
export const getReservationPage = (data = {}, config = {}) => {
    return request(API_URL + "/opr/reservation/page", data, config);
};
/**
 * 审核预约充电订单申诉
 * @param data
 * @param config
 * @returns
 */
export const auditReservationAppeal = (data = {}, config = {}) => {
    return request(API_URL + "/opr/reservation/appeal/audit", data, config);
};
/**
 * 预约充电订单申诉详情
 * @param data
 * @param config
 * @returns
 */
export const getReservationAppealDetails = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/reservation/appeal/detail", data, config);
};
/**
 * 统计预约充电订单
 * @param data
 * @param config
 * @returns
 */
export const getReservationsStat = (data = {}, config = {}) => {
    return request(API_URL + "/opr/reservation/stat", data, config);
};
/**
 * 获取预约充电订单详情
 * @param data
 * @param config
 * @returns
 */
export const getReservationsDetail = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/reservation/detail", data, config);
};
/**
 * 获取预约充电订单计费详情
 * @param data
 * @param config
 * @returns
 */
export const getReservationsBillingDetail = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/reservation/billing/detail", data, config);
};
/**
 * 查询预约单生命周期
 * @param data
 * @param config
 * @returns
 */
export const getReservationsRrderLife = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/reservation/order/life", data, config);
};
/**
 *  首页 - 查看站点规模统计信息
 * @param data
 * @param config
 * @returns
 */
export const getMapStaSize = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/size/statistics", data, config);
};
/**
 * 查询 搜索条件用的省市区
 * @param data
 * @param config
 * @returns
 */
export const getSearchFindAreaList = (data = {}, config = {}) => {
    return request(API_URL + "/stat/search/findAreaList", data, config);
};
/**
 *  首页 - 今日/昨日/累计数据 - 充电电量
 * @param data
 * @param config
 * @returns
 */
export const getHomeStatisticsElec = (data = {}, config = {}) => {
    return request(API_URL + "/stat/statistics/elec", data, config);
};
/**
 *  首页 - 今日/昨日/累计数据 - 充电次数
 * @param data
 * @param config
 * @returns
 */
export const getHomeStatisticsCharge = (data = {}, config = {}) => {
    return request(API_URL + "/stat/statistics/charge", data, config);
};
/**
 *  首页 - 今日/昨日/累计数据 - 实收数据看板
 * @param data
 * @param config
 * @returns
 */
export const getHomeStatisticsTrans = (data = {}, config = {}) => {
    return request(API_URL + "/stat/statistics/trans", data, config);
};
/**
 *  首页 - 今日/昨日/累计数据 - 使用率数据看板
 * @param data
 * @param config
 * @returns
 */
export const getHomeStatisticsUseRate = (data = {}, config = {}) => {
    return request(API_URL + "/stat/statistics/useRate", data, config);
};
/**
 *  首页 - 今日/昨日/累计数据 - 用户数
 * @param data
 * @param config
 * @returns
 */
export const getHomeStatisticsUser = (data = {}, config = {}) => {
    return request(API_URL + "/stat/statistics/user", data, config);
};
/**
 *  首页 - 充电数据
 * @param data
 * @param config
 * @returns
 */
export const getHomeStatChargeCurve = (data = {}, config = {}) => {
    return request(API_URL + "/stat/charge_curve", data, config);
};
/**
 *  首页 - 充电站昨日排名
 * @param data
 * @param config
 * @returns
 */
export const getHomeStatRanking = (data = {}, config = {}) => {
    return request(API_URL + "/stat/sta_ranking", data, config);
};
/**
 *  首页 - 充电枪状态
 * @param data
 * @param config
 * @returns
 */
export const getHomeStatGunStatus = (data = {}, config = {}) => {
    return request(API_URL + "/stat/gun_status", data, config);
};
/**
 *  运营分析
 * @param data
 * @param config
 * @returns
 */
export const getMerchantAnalysisOperation = (data = {}, config = {}) => {
    return request(API_URL + "/merchant/analysis/operation", data, config);
};
/**
 *  运营中心 商户营收统计
 * @param data
 * @param config
 * @returns
 */
export const getMchStatisticsAmount = (data = {}, config = {}) => {
    return request(API_URL + "/stat/mch/statistics/amount", data, config);
};
/**
 *  运营中心 商户充电订单统计
 * @param data
 * @param config
 * @returns
 */
export const getMchStatisticsOrder = (data = {}, config = {}) => {
    return request(API_URL + "/stat/mch/statistics/order", data, config);
};
/**
 *  运营中心 获取商户充电量图表
 * @param data
 * @param config
 * @returns
 */
export const getMchChartElec = (data = {}, config = {}) => {
    return request(API_URL + "/stat/mch/chart/elec", data, config);
};
/**
 *  运营中心 获取商户充电量图表
 * @param data
 * @param config
 * @returns
 */
export const TestAAA = (data = {}, config = {}) => {
    return request(API_URL + "/stat/mch/chart/elec", data, config);
};
